import { z } from 'zod';
import { createToolSignature } from './tool-signature';
import { ProspectSchema } from '../schemas/prospect.schema';
import { ChannelType } from '@zaplify/channel-accounts-shared';
export const formatMessageGenerationPromptToolSignature = createToolSignature({
    name: 'formatMessageGenerationPromptTool',
    description: 'Format the message generation prompt',
    inputSchema: z.object({
        globalMemories: z.string(),
        playbookMemories: z.string(),
        conversationMemories: z.string(),
        conversationHistory: z.string(),
        assistantSettings: z.object({
            purpose: z.string(),
            context: z.string().nullable(),
        }),
        userName: z.string(),
        prospect: ProspectSchema,
        channelType: z.enum([ChannelType.LINKEDIN, ChannelType.EMAIL]),
        chosenPath: z.string().nullable(),
        feedback: z.string().nullable(),
        messageToRegenerateSubjectLine: z.string().nullable(),
        messageToRegenerateContent: z.string().nullable(),
    }),
    outputSchema: z.object({
        messages: z.array(
            z.object({
                role: z.enum(['system', 'user', 'assistant']),
                content: z.string(),
            }),
        ),
    }),
    toolCallUi: (input) => `Formatting message generation prompt`,
});
